import ScrollButtons from './ScrollButtons';

export default ScrollButtons;
